import { all } from "redux-saga/effects";
import userSagas from "./user/saga";
import dealerSagas from "./dealer/saga";
import authSagas from "./auth/saga";
import countrySagas from "./country/saga";
import manualAddFundSagas from "./manualAddFund/saga";
import planSagas from "./plan/saga";
import networkSagas from "./network/saga";
import profileSagas from "./profile/saga";
import activationRequestSagas from "./activationRequest/saga";
import planWiseMappingSagas from "./planWiseMapping/saga";
import dashboardSagas from "./dashboard/saga";
import shortCodeSagas from "./shortCodeData/saga";
import activationStatusSaga from "./activationStatus/saga";
import mdnSwapSaga from "./MDNSwap/saga";
import chatrActivationSaga from "./chatrActivation/saga";
import simPinInventorySaga from "../redux/SIMPINInventory/saga";
import chatrActivationReportSaga from "../redux/ChatrActivationReport/saga";
import mdnSwapReportSaga from "../redux/MDNSwapReport/saga";
import chatrRechargePlanSaga from "../redux/chatrRechargePlan/saga";
import rechargePriceMappingSaga from "../redux/rechargePriceMapping/saga";
import chatrRechargeSaga from "../redux/Chatr Recharge Request/saga";

export default function* rootSaga() {
  yield all([
    userSagas(),
    dealerSagas(),
    countrySagas(),
    authSagas(),
    manualAddFundSagas(),
    planSagas(),
    networkSagas(),
    activationRequestSagas(),
    activationStatusSaga(),
    profileSagas(),
    planWiseMappingSagas(),
    dashboardSagas(),
    shortCodeSagas(),
    mdnSwapSaga(),
    chatrActivationSaga(),
    simPinInventorySaga(),
    chatrActivationReportSaga(),
    mdnSwapReportSaga(),
    chatrRechargePlanSaga(),
    rechargePriceMappingSaga(),
    chatrRechargeSaga(),
  ]);
}
